import FiltrarPrestamos from '../../../components/ui/Auditor/FiltrarPrestamosComponents/FiltrarPrestamos';

const FiltrarPrestamosUI = () => {
  return (
    <div className=" bg-gray-100">
        <FiltrarPrestamos />
    </div>
  );
};

export default FiltrarPrestamosUI;